<template>
	<div class="order-actions" v-if="orderExist">
		<button
			class="action-btn"
			:style="`background-color:${globalColors.primary};border-color:${globalColors.primary}`"
			@click="$emit('see-detail')"
		>Ver Pedido</button>
		<button
			v-if="unpaid"
			class="action-btn"
			:style="`background-color:${globalColors.primary};border-color:${globalColors.primary}`"
			@click="$emit('cancel-order')"
		>
			Cancelar Pedido
		</button>
	</div>
</template>

<script>
	export default {
		name: 'order-actions',
		props: {
			orderExist: {
				default: true,
				type: Boolean,
			},
			unpaid: {
				default: true,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.order-actions {
		align-items: center;
		display: flex;
		justify-content: center;
		margin-bottom: 50px;
	}

	.action-btn {
		border-radius: 4px;
		color: color(white);
		font-size: size(medium);
		height: 31px;
		margin: 0px 15px;
		min-width: 253px;
		text-transform: uppercase;
	}
</style>


// WEBPACK FOOTER //
// order-actions.vue?771a3396